module.exports = __webpack_public_path__ + "static/media/WEF-if-correct.e92af547.mp3";